import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'assigneeType',
})
export class AssigneeTypePipe implements PipeTransform {
  transform(assignees: any[]): string[] {
    return assignees.map((assignee: any) => assignee.type) ?? [];
  }
}
